import React from 'react';
import { Link } from 'react-router-dom';
import { APP_VERSION } from './version';
import './App.css';

function Footer() {
    return (
        <footer className="landing-footer" role="contentinfo">
            <div className="container">
                <p>
                    © {new Date().getFullYear()} JaPamietam.pl | <Link to="/regulamin">Regulamin</Link> | <Link to="/polityka-prywatnosci">Polityka Prywatności tekst</Link>
                </p>
                <p className="footer-contact-info">
                    NIP: 8971850739 <br />
                    Kontakt: <a href="mailto:kontakt.japamietam@gmail.com">kontakt.japamietam@gmail.com</a>
                </p>
                <p className="footer-version">Wersja: {APP_VERSION}</p>
            </div>
        </footer>
    );
}

export default Footer;
